import { render, staticRenderFns } from "./review-list-sort.vue?vue&type=template&id=44623b0e&"
import script from "./review-list-sort.vue?vue&type=script&lang=js&"
export * from "./review-list-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports